import { Component, OnInit, inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Tab } from '@peca/design-system';


@Component({
  selector: 'peca-optimizer-tab',
  templateUrl: './optimizer-tab.component.html',
  styleUrls: ['./optimizer-tab.component.scss'],
  standalone: false,
})
export class OptimizerTabComponent implements OnInit {

  breadcrumb = [
    { label: 'Operações', path: '/operacoes' },
    { label: 'Otimizador' },
  ];

  tabs: Tab[] = [
    { label: 'Configurações', target: 'configuracoes', active: true, roles: [], path: 'configuracoes' },
    { label: 'Logs', target: 'logs', active: false, roles: [], path: 'logs' },
  ];
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  get activeTab(): string {
    return this.tabs.find((t) => t.active)?.target ?? 'configuracoes';
  }

  private updateActiveFromUrl(): void {
    const child = this.route.firstChild?.snapshot.url[0]?.path;
    this.tabs.forEach((t) => (t.active = t.path === child));
    this.updateBreadcrumb();
  }

  onTabSelected(tab: Tab): void {
    this.tabs.forEach((t) => (t.active = false));
    tab.active = true;
    this.updateBreadcrumb();

    if (tab.path) {
      this.router.navigate([tab.path], { relativeTo: this.route });
    }
  }

  ngOnInit(): void {
    this.updateActiveFromUrl();
  }

  private updateBreadcrumb(): void {
    const active = this.tabs.find((t) => t.active);
    this.breadcrumb = [
      { label: 'Operações', path: '/operacoes' },
      { label: 'Otimizador' },
      { label: active?.label ?? 'Configurações' },
    ];
  }
}
